<div class="container py-3">
  <h2 class="mb-3">My Profile</h2>

  <!-- Single subsection with single-column fields -->
  <div class="subsection mt-2" *ngIf="selectedUser">
    <div class="d-flex justify-content-between align-items-center mb-2 subheader">
      <h4 class="m-0 subsection-title">Profile Name: <span class="mp-value ms-1">{{ profileName || 'N/A' }}</span></h4>
    </div>
    <div style="max-width: 720px;">
      <div class="mb-2"><label>User ID:</label> <span class="mp-value ms-1">{{ selectedUser.userId }}</span></div>
      <div class="mb-2"><label>Email:</label> <span class="mp-value ms-1">{{ selectedUser.email }}</span></div>
      <div class="mb-2"><label>Authentication By:</label> <span class="mp-value ms-1">{{ selectedUser.authType }}</span></div>
      <div class="mb-2"><label>Max Mountpoints Allowed:</label> <span class="mp-value ms-1">{{ selectedUser.maxMpNumber }}</span></div>
      <div class="mb-2"><label>Max Clients Allowed:</label> <span class="mp-value ms-1">{{ selectedUser.maxClientNumber }}</span></div>
      <div class="mb-2"><label>Account Creation Date:</label> <span class="mp-value ms-1">{{ selectedUser.creationDate | date:'yyyy-MM-dd' }}</span></div>
      <div class="mb-2"><label>Account Enabled?</label> <input type="checkbox" class="form-check-input ms-1" [ngModel]="selectedUser.active" name="active" disabled></div>
      <div class="mb-3">
        <span class="d-inline-flex align-items-center gap-2">
          <button class="btn btn-warning" (click)="onDeleteAllNtripData()">Clear data</button>
          <button type="button"
                  class="btn btn-link btn-sm p-0 text-muted"
                  matTooltip="Clears all data previously downloaded from your RTK base station(s), including data downloaded via Get RTK Base Location, PPK Downloader, and RTK Base Analyzer."
                  aria-label="Clear data help">
            <span class="material-icons" style="font-size: 16px; vertical-align: middle;">info</span>
          </button>
        </span>
      </div>
    </div>
  </div>
</div>

